"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.deleteAttachmentLink = deleteAttachmentLink;
exports.batchDeleteAttachmentLink = batchDeleteAttachmentLink;
exports.resetPassword = resetPassword;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _utils2 = require("../utils");

var endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/attachment_link/all");
    }
  },
  "delete": {
    method: 'DELETE',
    url: function url(messageId) {
      return "/".concat(_utils2.API_V1, "/attachment_link/").concat(messageId);
    }
  },
  resetPassword: {
    method: 'PUT',
    url: function url(messageId) {
      return "/".concat(_utils2.API_V1, "/attachment_link/resetpassword/").concat(messageId);
    }
  },
  batchDelete: {
    method: 'POST',
    url: function url() {
      return "/".concat(_utils2.API_V1, "/attachment_link/batchdelete");
    }
  }
};
exports.endpoints = endpoints;

/**
 * Get all attachment link for the user
 *
 * @public
 * @returns {Promise<ListResponse>}
 */
function list(_x, _x2) {
  return _list.apply(this, arguments);
}

function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(keyword, auth) {
    var optionals, _endpoints$list, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              keyword: keyword
            }))(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}

/**
 * Delete attachment link
 *
 * @public
 * @param {string} messageId - message Id
 * @param {Auth} auth - User authentication info
 * @returns {Promise<DeleteAttachmentLinkResponse>}
 */
function deleteAttachmentLink(_x3, _x4) {
  return _deleteAttachmentLink.apply(this, arguments);
}

function _deleteAttachmentLink() {
  _deleteAttachmentLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(messageId, auth) {
    var optionals, _endpoints$delete, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
            _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
            _context2.next = 4;
            return (0, _requests.request)(url(messageId), method, optionals);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _deleteAttachmentLink.apply(this, arguments);
}

/**
 * Batch delete attachment links
 *
 * @public
 * @param {Array<string>} messageIds - message Ids
 * @param {Auth} auth - User authentication info
 * @returns {Promise<BatchDeleteAttachmentLinkResponse>}
 */
function batchDeleteAttachmentLink(_x5, _x6) {
  return _batchDeleteAttachmentLink.apply(this, arguments);
}

function _batchDeleteAttachmentLink() {
  _batchDeleteAttachmentLink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(messageIds, auth) {
    var optionals, _endpoints$batchDelet, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              messageIds: messageIds
            }))(_utils.defaultOptionals);
            _endpoints$batchDelet = endpoints.batchDelete, method = _endpoints$batchDelet.method, url = _endpoints$batchDelet.url;
            _context3.next = 4;
            return (0, _requests.request)(url(), method, optionals);

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _batchDeleteAttachmentLink.apply(this, arguments);
}

/**
 * Reset password of attachment link
 *
 * @public
 * @param {string} messageId - message Id
 * @param {string} password - new password
 * @param {Auth} auth - User authentication info
 * @returns {Promise<ResetPasswordResponse>}
 */
function resetPassword(_x7, _x8, _x9) {
  return _resetPassword.apply(this, arguments);
}

function _resetPassword() {
  _resetPassword = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(messageId, password, auth) {
    var optionals, _endpoints$resetPassw, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              password: password
            }))(_utils.defaultOptionals);
            _endpoints$resetPassw = endpoints.resetPassword, method = _endpoints$resetPassw.method, url = _endpoints$resetPassw.url;
            _context4.next = 4;
            return (0, _requests.request)(url(messageId), method, optionals);

          case 4:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _resetPassword.apply(this, arguments);
}
//# sourceMappingURL=attachment-links.js.map